'use client';

import React from 'react';

const LoadingSpinner = ({ message = "Loading..." }) => {
  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center">
      <div className="relative w-[200px] h-[200px]">
        {/* Star 1 */}
        <svg 
          className="absolute w-[60px] h-[60px] top-[10px] left-[70px] fill-[#d4a017] opacity-0 origin-center animate-[pulseStar_2s_infinite]" 
          viewBox="0 0 51 48" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M25.5 0L31.4 18.1H50.5L35 29.4L40.9 47.5L25.5 36.3L10.1 47.5L16 29.4L0.5 18.1H19.6L25.5 0Z"/>
        </svg>
        
        {/* Star 2 */}
        <svg 
          className="absolute w-[40px] h-[40px] top-[50px] right-[30px] fill-[#d4a017] opacity-0 origin-center animate-[pulseStar_2s_infinite_0.6s]" 
          viewBox="0 0 51 48" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M25.5 0L31.4 18.1H50.5L35 29.4L40.9 47.5L25.5 36.3L10.1 47.5L16 29.4L0.5 18.1H19.6L25.5 0Z"/>
        </svg>
        
        {/* Star 3 */}
        <svg 
          className="absolute w-[35px] h-[35px] top-[110px] right-[50px] fill-[#d4a017] opacity-0 origin-center animate-[pulseStar_2s_infinite_1.2s]" 
          viewBox="0 0 51 48" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="M25.5 0L31.4 18.1H50.5L35 29.4L40.9 47.5L25.5 36.3L10.1 47.5L16 29.4L0.5 18.1H19.6L25.5 0Z"/>
        </svg>
      </div>
      <p className="mt-4 text-[#003399] font-bold text-lg">{message}</p>
      <style jsx global>{`
        @keyframes pulseStar {
          0% {
            opacity: 0;
            transform: scale(0.5);
          }
          50% {
            opacity: 1;
            transform: scale(1);
          }
          100% {
            opacity: 0;
            transform: scale(0.5);
          }
        }
      `}</style>
    </div>
  );
};

export default LoadingSpinner; 